// src/components/tutor/mobile/MobileBottomNav.js
import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LuMegaphone, LuClock, LuCalendar, LuUser, LuLightbulb } from "react-icons/lu";

const NAV_ITEMS = [
  { key: "announcements", Icon: LuMegaphone,  label: "News"         },
  { key: "suggestions",   Icon: LuLightbulb,  label: "Ideas"        },
  { key: "availability",  Icon: LuClock,      label: "Availability" },
  { key: "schedule",      Icon: LuCalendar,   label: "Schedule"     },
  { key: "profile",       Icon: LuUser,       label: "Profile"      },
];

export default function MobileBottomNav({
  activeTab,
  onTabChange,
  unreadCount = 0,
  suggestionCount = 0,
  suggestionTone = "none",
}) {
  return (
    <div className="luma-nav-wrapper">
      <div className="luma-nav-pill">
        {NAV_ITEMS.map(({ key, Icon, label }) => {
          const isActive = activeTab === key;
          const badgeCount = key === "announcements" ? unreadCount : key === "suggestions" ? suggestionCount : 0;
          const badgeMuted = key === "suggestions" && suggestionTone === "muted";
          return (
            <button
              key={key}
              className="luma-nav-btn"
              onClick={() => onTabChange(key)}
              aria-label={label}
            >
              {isActive && (
                <motion.div
                  layoutId="luma-active-bg"
                  className="luma-active-bg"
                  initial={false}
                  transition={{ type: "spring", stiffness: 500, damping: 35 }}
                />
              )}

              <motion.div
                className={`luma-icon-wrap ${isActive ? "luma-icon-wrap--active" : ""}`}
                animate={{ scale: isActive ? 1.15 : 1 }}
                transition={{ type: "spring", stiffness: 400, damping: 22 }}
              >
                {/* Unread badge on the Announcements tab; suggestion status badge on Ideas */}
                {(key === "announcements" || key === "suggestions") && (
                  <AnimatePresence>
                    {badgeCount > 0 && (
                      <motion.span
                        key="badge"
                        className={`luma-badge ${badgeMuted ? "luma-badge--muted" : ""}`}
                        initial={{ scale: 0, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0, opacity: 0 }}
                        transition={{ type: "spring", stiffness: 600, damping: 20 }}
                      >
                        {badgeCount > 99 ? "99+" : badgeCount}
                      </motion.span>
                    )}
                  </AnimatePresence>
                )}

                <Icon size={22} />
              </motion.div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
